export const FINANCE_ROUTE_PREFIX = '/finance';
